import {
  benefitChoice,
  comparison,
  config,
  credit,
  dealer,
  equipments,
  favorite,
  filterChoice,
  filterPanel,
  filterValues,
  installation,
  marketingInfo,
  pagination,
  reference,
  rootReducer as instockReducer,
  tradeIn,
  vehicle,
  vehicleEquipment,
} from '@perxis-auto/instock-sdk/lib/app';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';

const rootReducer = instockReducer
  .inject(dealer.api)
  .inject(vehicle.api)
  .inject(vehicleEquipment.api)
  .inject(filterValues.api)
  .inject({ reducerPath: benefitChoice.reducerPath, reducer: benefitChoice.reducer })
  .inject({ reducerPath: comparison.reducerPath, reducer: comparison.reducer })
  .inject({ reducerPath: config.reducerPath, reducer: config.reducer })
  .inject({ reducerPath: credit.reducerPath, reducer: credit.reducer })
  .inject({ reducerPath: equipments.reducerPath, reducer: equipments.reducer })
  .inject({ reducerPath: favorite.reducerPath, reducer: favorite.reducer })
  .inject({ reducerPath: filterChoice.reducerPath, reducer: filterChoice.reducer })
  .inject({ reducerPath: filterPanel.reducerPath, reducer: filterPanel.reducer })
  .inject({ reducerPath: installation.reducerPath, reducer: installation.reducer })
  .inject({ reducerPath: marketingInfo.reducerPath, reducer: marketingInfo.reducer })
  .inject({ reducerPath: pagination.reducerPath, reducer: pagination.reducer })
  .inject({ reducerPath: reference.reducerPath, reducer: reference.reducer })
  .inject({ reducerPath: tradeIn.reducerPath, reducer: tradeIn.reducer });

export const setupStore = (preloadedState?: AppStateType) => {
  const store = configureStore({
    preloadedState,
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(dealer.api.middleware)
        .concat(vehicle.api.middleware)
        .concat(vehicleEquipment.api.middleware)
        .concat(filterValues.api.middleware)
        .concat(filterValues.middleware)
        .concat(filterChoice.middleware)
        .concat(installation.middleware)
        .concat(config.middleware),
  });

  const persistor = persistStore(store);

  return {
    store,
    persistor,
  };
};

export type AppStoreType = ReturnType<typeof setupStore>['store'];

export type AppStateType = ReturnType<typeof rootReducer>;

export type AppDispatchType = AppStoreType['dispatch'];
